import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionExtracted = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 23 22" fill="none">
    <g fill="currentColor">
      <path d="M11.1825 8.81825C11.7683 8.23246 12.718 8.23246 13.3038 8.81825C13.8896 9.40404 13.8896 10.3538 13.3038 10.9396C12.718 11.5254 11.7683 11.5254 11.1825 10.9396C10.5967 10.3538 10.5967 9.40404 11.1825 8.81825Z" />
      <path d="M15.9143 6.9998L12.2454 4.79834L8.57129 7.00271V8.67845L12.2454 6.46453L15.9143 8.67845V6.9998Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1618 2L17.9952 5.5V12.2683L21.0069 14.0071L18.0947 15.6348L18.0948 19.3661L12.2136 15.9706L6.10052 19.5L6.10066 15.7688L3.18848 14.141L6.32849 12.3282V5.5L12.1618 2ZM7.32849 6.06619L12.1618 3.16619L16.9952 6.06619V11.9338L12.1618 14.8338L7.32849 11.9338V6.06619ZM7.16328 13.0009L5.21287 14.1269L6.71871 14.9686L8.58079 13.8514L7.16328 13.0009ZM9.55261 14.4345L7.10066 15.9056L7.10059 17.7679L11.1815 15.4118L9.55261 14.4345ZM13.193 15.3813L17.0948 17.634L17.0947 15.8231L14.7757 14.4317L13.193 15.3813ZM15.7475 13.8486L17.4323 14.8595L18.9825 13.993L17.2112 12.9704L15.7475 13.8486Z"
      />
    </g>
  </svg>,
  'TransactionExtracted'
);
